import { apiFetch } from './client';

export const listSubcategories = (token) => apiFetch(token, '/subcategories');

export const createSubcategory = (token, payload) =>
  apiFetch(token, '/subcategories', { method: 'POST', body: JSON.stringify(payload) });

export const updateSubcategory = (token, subcategoryId, payload) =>
  apiFetch(token, `/subcategories/${subcategoryId}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });

export const deleteSubcategory = (token, subcategoryId) =>
  apiFetch(token, `/subcategories/${subcategoryId}`, { method: 'DELETE' });
